import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=3277553e&scoped=true"
import script from "./credits.vue?vue&type=script&lang=js"
export * from "./credits.vue?vue&type=script&lang=js"
import style0 from "./credits.vue?vue&type=style&index=0&id=3277553e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3277553e",
  null
  
)

export default component.exports